(function($) {
    if(!document.querySelector('body.gp-endpoint-pos-returns')){
        return;
    }

    let returns_container = document.querySelector('.pos__returns');

    function get_returns(){
        return document.querySelectorAll('.pos__returns_return');
    }
    /**
     * Search
     */
    let current_request = null;
    function update_view_state(state)
    {
        returns_container.setAttribute('data-status', state);
    }
    function update_view() {
        let input = $('.pos__search_input').val().trim();
        if(current_request){
            current_request.abort();
            current_request = null;
        }
        if(!input){
            update_view_state('clear');
            return;
        }
        update_view_state('loading');

        let this_request = current_request = gp_ajax({
            url: ghostpress_params.ajax_url,
            type: 'POST',
            dataType: 'json',
            data: {
                action: 'return_search',
                term: input
            },

        }).done(() => {
            if(this_request !== current_request){
                return;
            }
            current_request = null;
            // sort items
            app_status.search = input;
            update_app();
            // show them
            update_view_state('content');
        }).fail(() => {
            if(this_request !== current_request){
                return;
            }
            current_request = null;
            update_view_state('error');
        });
    }

    /**
     * Main app
     */

    let app_status = {
        sort_column: '',
        sort_reverse: false,
        search: '',
    };
    let old_status = { ...app_status };

    function update_app(){
        let do_sort = false;
        if(old_status.sort_column !== app_status.sort_column || old_status.sort_reverse !== app_status.sort_reverse){
            render_sort_column();
            do_sort = true;
        }

        if(old_status.search !== app_status.search){
            do_sort = true;
        }
        if(do_sort){
            sort_returns();
        }
        old_status = { ...app_status };
    }

    function render_sort_column()
    {
        // remove old classes
        document.querySelectorAll(".pos__returns_filter-col[data-sort-by].--active").forEach(function(item){
            item.classList.remove('--active');
            item.classList.remove('--reverse');
        });
        // add new class
        document.querySelectorAll('.pos__returns_filter-col[data-sort-by="'+app_status.sort_column+'"]').forEach(function(item){
            item.classList.add('--active');
            if(app_status.sort_reverse){
                item.classList.add('--reverse');
            }
        });
    }


    /**
     * Sorting
     */
    const compare_numbers = function(a, b) {
        const compare = b.val - a.val;
        return compare === 0 ? a.number - b.number : compare;
    }
    const compare_strings = function(a, b){
        const valA = a.val; // ignore upper and lowercase
        const valB = b.val; // ignore upper and lowercase
        if (valA < valB) {
            return -1;
        }
        if (valA > valB) {
            return 1;
        }

        // equal names - use numbers for sorting
        return a.number - b.number;
    }

    function sort_returns()
    {
        let value_col = 'data-' + app_status.sort_column;
        let order_values = [];
        // get values
        get_returns().forEach(function (order){
            order_values.push({
                'val': order.getAttribute(value_col),
                'order': order,
                'number': order.getAttribute('data-order-number'),
            })
        });
        // sort orders
        let sort_function = compare_strings;
        if(app_status.sort_column === 'total' || app_status.sort_column === 'order-number' || app_status.sort_column === 'return-id'){
            sort_function = compare_numbers;
        }

        order_values.sort(sort_function);
        // sort nodes
        order_values.forEach(function (item){
            if(app_status.sort_reverse){
                item.order.parentNode.prepend(item.order);
            }else{
                item.order.parentNode.appendChild(item.order);
            }
        });
    }


    /**
     * App changes
     */

    app_status.sort_column = 'return-id';
    update_app();

    $('.pos__search_input').on('input', function (){
        update_view();
    }).on('keydown', function(e){
        if(e.key === 'Escape'){
            let $inputs = $('.pos__search_input');
            $inputs.val(''); // clear value
            $inputs.trigger('input');
        }
    })
    $('.pos__search_form').on('submit', function(e){
        e.preventDefault();
        update_view();
    })
    $('.pos__search_clear').on('click', function(){
        let $inputs = $('.pos__search_input');
        $inputs.val(''); // clear value
        $inputs.trigger('input');
    });

    $('.pos__returns_filter-col[data-sort-by]').on('click', function(){
        const sort_column = this.getAttribute('data-sort-by');
        if(sort_column === app_status.sort_column){
            app_status.sort_reverse = !app_status.sort_reverse;
        }else{
            app_status.sort_column = sort_column;
            app_status.sort_reverse = false;
        }
        update_app();
    });


})(jQuery);